import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { projectsApi } from "../api/projects";
import "../styles/pages.css";

function ProjectDetailPage() {
  const { slug } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    projectsApi.getBySlug(slug)
      .then((data) => setProject(data))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <>
        <Navbar />
        <main className="cdh-page cdh-page--reader">
          <div className="cdh-state">Loading…</div>
        </main>
        <Footer />
      </>
    );
  }

  if (error || !project) {
    return (
      <>
        <Navbar />
        <main className="cdh-page cdh-page--reader">
          <div className="cdh-state cdh-state--error">
            {error ? `Failed to load: ${error}` : "Project not found."}
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <main className="cdh-page cdh-page--reader">
        <div className="cdh-back-wrap">
          <Link to="/projects" className="cdh-back">
            ← All Projects
          </Link>
        </div>

        <div className="cdh-project">
          <div className="cdh-project__header">
            <div className="cdh-card__tags">
              {(typeof project.tags === "string" ? JSON.parse(project.tags) : project.tags).map((t) => (
                <span key={t} className="cdh-card__tag">{t}</span>
              ))}
            </div>
            <h1 className="cdh-project__title">{project.title}</h1>
            <p className="cdh-project__desc">{project.description}</p>
          </div>

          <div className="cdh-project__media">
            {project.demo_video_url ? (
              <video
                src={project.demo_video_url}
                autoPlay
                muted
                loop
                playsInline
                controls
                controlsList="nodownload"
                onContextMenu={(e) => e.preventDefault()}
                style={{ width: "100%", borderRadius: "8px" }}
              />
            ) : project.cover_image_url ? (
              <img src={project.cover_image_url} alt={project.title} />
            ) : (
              <div className="cdh-project__media-placeholder">
                Demo video coming soon
              </div>
            )}
          </div>

          <div className="cdh-project__body">
            {project.content ? (
              <div
                className="rr-body"
                dangerouslySetInnerHTML={{ __html: project.content }}
              />
            ) : (
              <>
                <div className="cdh-project__section">
                  <h3>The Problem</h3>
                  <p>{project.problem}</p>
                </div>
                <div className="cdh-project__section">
                  <h3>What We Built</h3>
                  <p>{project.solution}</p>
                </div>
                <div className="cdh-project__section">
                  <h3>Outcome</h3>
                  <p>{project.outcome}</p>
                </div>
              </>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default ProjectDetailPage;
